
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getQaDataForMap",
      resolverType: "query",
      routePath: "/getQaDataForMap",
      httpMethod: "POST",
    });
  